import React, { createContext, useContext, useState, useEffect } from 'react';
import { getInfoUsers } from '../services/ApiGetUserInfo';
import { ProfileType } from '../model/datatype';

interface UserContextType {
  userInfo: ProfileType | null;
  isLoading: boolean;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [userInfo, setUserInfo] = useState<ProfileType | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        // 1. Check cache in sessionStorage first
        const cache = sessionStorage.getItem('obj_user_info');
        const email = sessionStorage.getItem('email') || undefined;
        if (cache) {
          setUserInfo(JSON.parse(cache));
          setIsLoading(false);
          return;
        }
        // 2. If no cache, fetch from API
        const response = await getInfoUsers(email);
        setUserInfo(response);
        setIsLoading(false);
        // Save to cache
        sessionStorage.setItem('obj_user_info', JSON.stringify(response));
      } catch (error) {
        console.error('Failed to fetch user info:', error);
        setIsLoading(false);
      }
    };
    fetchUserInfo();
  }, []);

  return (
    <UserContext.Provider value={{ userInfo, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
